module.exports = __webpack_public_path__ + "static/media/fwhome.64f36536.png";